import { useQuery } from "react-query";
import { getAdminAdvertisements } from "api/services/advertisements";
import { EAdvertisementsQueryKeys } from "api/endpoints/advertisements";
import { logError } from "utils/notifications";
import { TApiError } from "types/api/error";
import { TAdvertisement } from "types/api/advertisement";

export const useAdminAdvertisements = () => {
  return useQuery<TAdvertisement[], TApiError>(
    [EAdvertisementsQueryKeys.getAdminAdvertisements],
    getAdminAdvertisements,
    {
      onError: (error) => logError({ error }),
      retry: false,
    }
  );
};
